<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">練習列表</h1>
        <p class="page-subtitle">管理不同課程版本的練習內容，支援新增、編輯、刪除和查看詳情</p>
      </div>
      <div class="header-right">
        <el-button
            size="small"
            type="warning"
            v-if="userInfoRoleRoleId !== teacherRoleId"
            @click="onAdd"
            icon="el-icon-plus"
        >
          新增練習
        </el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 筛选搜索区 -->
      <div class="search-card">
        <!-- PC端筛选栏（≥768px显示） -->
        <div class="pc-search">
          <div class="search-row">
            <div class="search-item">
              <div class="search-text">練習編號</div>
              <el-input
                  v-model="formLabelAlign.numberLike"
                  placeholder="練習編號"
                  size="small"
                  clearable
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">課程版本</div>
              <el-select
                  v-model="formLabelAlign.lang"
                  placeholder="請選擇課程版本"
                  size="small"
                  clearable
              >
                <el-option
                    v-for="item in languages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item search-button">
              <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">
                搜尋
              </el-button>
            </div>
            <div class="search-item reset-button">
              <el-button size="small" type="default" @click="onReset" icon="el-icon-refresh">
                重置
              </el-button>
            </div>
          </div>
        </div>

        <!-- 移动端筛选栏（<768px显示） -->
        <div class="mobile-search">
          <el-collapse>
            <el-collapse-item title="篩選條件" name="1">
              <div class="mobile-search-form">
                <el-form size="small" label-width="80px">
                  <el-form-item label="練習編號">
                    <el-input
                        v-model="formLabelAlign.numberLike"
                        placeholder="練習編號"
                        clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="課程版本">
                    <el-select
                        v-model="formLabelAlign.lang"
                        placeholder="請選擇課程版本"
                        clearable
                    >
                      <el-option
                          v-for="item in languages"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <div class="mobile-search-buttons">
                      <el-button type="warning" @click="onSearch" icon="el-icon-search" style="width: 48%;">
                        搜尋
                      </el-button>
                      <el-button @click="onReset" icon="el-icon-refresh" style="width: 48%;">
                        重置
                      </el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%;"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無練習數據' : ''"
          >
            <el-table-column
                prop="number"
                label="練習編號"
                align="center"
                sortable="custom"
                min-width="120"
            >
              <template slot-scope="{ row }">
                <span class="practice-number">{{ row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="描述"
                align="center"
                min-width="180"
            >
              <template slot-scope="{row}">
                <div class="describe-text" v-if="row.desc">{{ row.desc }}</div>
                <span v-else class="empty-text">-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="lang"
                label="課程版本"
                align="center"
                min-width="100"
            >
              <template slot-scope="{row}">
                <el-tag size="mini" :type="row.lang === 0 ? 'info' : 'success'">
                  {{row.lang | language}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="updatedAt"
                label="最後更新時間"
                align="center"
                sortable="custom"
                min-width="160"
            >
              <template slot-scope="{row}">
                <span>{{row.updatedAt | formatDateTime}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="editor"
                label="最後更新帳號"
                align="center"
                min-width="120"
            >
              <template slot-scope="{row}">
                <span>{{row.editor || '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="180">
              <template slot-scope="{ row }">
                <div class="operation-group">
                  <el-button
                      v-if="userInfoRoleRoleId !== teacherRoleId"
                      type="text"
                      size="small"
                      @click="onEditButton(row.id)"
                      icon="el-icon-edit"
                      class="edit-btn"
                  >
                    編輯
                  </el-button>
                  <el-button
                      v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId"
                      type="text"
                      size="small"
                      @click="onDeleteButton(row.id)"
                      icon="el-icon-delete"
                      class="delete-btn"
                  >
                    刪除
                  </el-button>
                  <el-button
                      type="text"
                      size="small"
                      @click="onDetailButton(row.id)"
                      icon="el-icon-view"
                      class="detail-btn"
                  >
                    詳情
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="practice-card" v-for="(row, index) in tableData" :key="row.id || index">
            <!-- 卡片头部：练习编号 + 语言 -->
            <div class="card-header">
              <div class="practice-number">{{ row.number }}</div>
              <el-tag size="mini" :type="row.lang === 0 ? 'info' : 'success'">
                {{row.lang | language}}
              </el-tag>
            </div>

            <!-- 卡片主体 -->
            <div class="card-body">
              <div class="practice-desc" v-if="row.desc">
                <div class="desc-label">練習描述：</div>
                <div class="desc-content">{{ row.desc }}</div>
              </div>
              <div class="practice-desc empty-desc" v-else>
                <div class="desc-content">無練習描述</div>
              </div>

              <div class="practice-meta">
                <div class="meta-item">
                  <i class="el-icon-time"></i>
                  <span>最後更新：{{row.updatedAt | formatDateTime}}</span>
                </div>
                <div class="meta-item" v-if="row.editor">
                  <i class="el-icon-user"></i>
                  <span>更新帳號：{{row.editor}}</span>
                </div>
              </div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <div class="action-group">
                <el-button
                    v-if="userInfoRoleRoleId !== teacherRoleId"
                    type="text"
                    size="mini"
                    @click="onEditButton(row.id)"
                    icon="el-icon-edit"
                    class="edit-btn"
                >
                  編輯
                </el-button>
                <el-button
                    v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId"
                    type="text"
                    size="mini"
                    @click="onDeleteButton(row.id)"
                    icon="el-icon-delete"
                    class="delete-btn"
                >
                  刪除
                </el-button>
                <el-button
                    type="text"
                    size="mini"
                    @click="onDetailButton(row.id)"
                    icon="el-icon-view"
                    class="detail-btn"
                >
                  詳情
                </el-button>
              </div>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            <i class="el-icon-document-empty"></i>
            <p>暫無練習數據</p>
            <el-button
                size="small"
                type="warning"
                v-if="userInfoRoleRoleId !== teacherRoleId"
                @click="onAdd"
                icon="el-icon-plus"
            >
              立即新增
            </el-button>
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container" v-show="total > 0">
        <Pagination
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getPractises"
        />
      </div>
    </div>

    <!-- 删除确认对话框 -->
    <deleteDialog
        titleCh="您確定要將此練習刪除嗎?"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getPractises, deletePractise } from "@/api/practises";
import deleteDialog from "@/components/deleteDialog";

export default {
  components: { deleteDialog, Pagination },
  filters: {
    // 语言过滤器
    language(value) {
      return value === 0 ? '中文' : '英文';
    },
    // 日期时间格式化过滤器
    formatDateTime(value) {
      if (!value) return '未設定';
      const date = new Date(value);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  },
  data() {
    return {
      // 语言选项
      languages: [
        { value: 0, label: '中文' },
        { value: 1, label: '英文' }
      ],
      // 角色权限相关
      userInfoRoleRoleId: this.$store.getters.userInfo?.role?.roleId || '',
      teacherRoleId: 'teacher',
      editorRoleId: 'editor',
      total: 0,
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        lang: null,
        topicId: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    this.getPractises();
  },
  methods: {
    // 路由跳转方法
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 排序处理
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getPractises();
    },
    // 重置筛选
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key === "_page") {
          this.formLabelAlign[key] = 1;
        } else if (key === "_limit") {
          this.formLabelAlign[key] = 10; // 恢复默认10条/页
        }
      });
      this.getPractises();
      this.$message.info("篩選條件已重置");
    },
    // 搜索
    onSearch() {
      this.formLabelAlign._page = 1; // 搜索时重置页码
      this.getPractises();
    },
    // 取消对话框
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 确认删除
    confirmFunction() {
      this.deletePractise();
    },
    // 新增练习
    onAdd() {
      let path = `/practice/add`;
      this.resolveRouter(path);
    },
    // 编辑练习
    onEditButton(id) {
      if (!id) {
        this.$message.warning("練習ID不存在，無法編輯");
        return;
      }
      let path = `/practice/${id}/edit`;
      this.resolveRouter(path);
    },
    // 查看详情
    onDetailButton(id) {
      if (!id) {
        this.$message.warning("練習ID不存在，無法查看詳情");
        return;
      }
      let path = `/practice/${id}`;
      this.resolveRouter(path);
    },
    // 删除练习（弹窗）
    onDeleteButton(id) {
      if (!id) {
        this.$message.warning("練習ID不存在，無法刪除");
        return;
      }
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    // 执行删除
    deletePractise() {
      const loading = this.$loading({
        lock: true,
        text: '刪除中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      deletePractise(this.orderId)
          .then(() => {
            this.$message.success("刪除成功");
            this.getPractises();
          })
          .catch(err => {
            console.error('删除练习失败：', err);
            this.$message.error("刪除失敗，請稍後重試");
          })
          .finally(() => {
            this.centerDialogVisible = false;
            loading.close();
          });
    },
    // 获取练习列表
    getPractises() {
      let formLabelAlign = {
        numberLike: this.formLabelAlign.numberLike,
        lang: this.formLabelAlign.lang,
        topicId: this.formLabelAlign.topicId,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };

      const loading = this.$loading({
        lock: true,
        text: '加載練習數據中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      getPractises(formLabelAlign)
          .then((v) => {
            this.tableData = v.data || [];
            this.total = Number(v.headers["x-total-count"]) || 0;
          })
          .catch(err => {
            console.error('获取练习列表失败：', err);
            this.$message.error("獲取練習列表失敗，請稍後重試");
            this.tableData = [];
            this.total = 0;
          })
          .finally(() => {
            loading.close();
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 搜索卡片样式 */
.search-card {
  //margin-bottom: 20px;

  /* PC端搜索样式 */
  .pc-search {
    .search-row {
      display: grid;
      grid-template-columns: repeat(2, 1fr) 100px 100px;
      gap: 12px;
      padding: 16px;
      background: #f8f9fa;
      border-radius: 6px;

      .search-item {
        .search-text {
          margin-bottom: 4px;
          font-size: 12px;
          color: #6c757d;
          font-weight: 500;
        }
      }

      .search-button, .reset-button {
        display: flex;
        align-items: flex-end;

        .el-button {
          width: 100%;
        }
      }
    }
  }

  /* 移动端搜索样式 */
  .mobile-search {
    display: none;

    .mobile-search-form {
      padding: 16px 8px;
    }

    .mobile-search-buttons {
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }
  }
}

/* 数据容器样式 */
.data-container {
  width: 100%;
  margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      .practice-number {
        font-weight: 600;
        color: #166ea5;
      }

      .describe-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
      }

      .empty-text {
        color: #999;
      }

      .operation-group {
        display: flex;
        justify-content: center;
        gap: 8px;
        flex-wrap: wrap;
      }

      .edit-btn {
        color: #409eff;
      }

      .delete-btn {
        color: #f56c6c;
      }

      .detail-btn {
        color: #166ea5;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 练习卡片 */
    .practice-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.2s ease;

      &:hover {
        border-color: #166ea5;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      /* 卡片头部 */
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e9ecef;

        .practice-number {
          font-size: 18px;
          font-weight: 600;
          color: #166ea5;
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 12px;

        .practice-desc {
          margin-bottom: 12px;

          .desc-label {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 4px;
          }

          .desc-content {
            font-size: 14px;
            color: #1f2937;
            line-height: 1.5;
          }
        }

        .empty-desc {
          .desc-content {
            color: #999;
            font-style: italic;
          }
        }

        .practice-meta {
          display: flex;
          flex-direction: column;
          gap: 6px;

          .meta-item {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: #6c757d;

            i {
              font-size: 12px;
              color: #166ea5;
              width: 14px;
              text-align: center;
            }
          }
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        padding-top: 12px;
        border-top: 1px solid #e9ecef;

        .action-group {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0 0 20px 0;
      }
    }
  }
}

/* 分页容器 */
.pagination-container {
  text-align: right;
  padding: 10px 0;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 隐藏PC搜索，显示移动端搜索 */
  .search-card .pc-search {
    display: none;
  }
  .search-card .mobile-search {
    display: block;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }
  .data-container .mobile-cards {
    display: flex;
  }

  /* 分页适配 */
  .pagination-container {
    text-align: center;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    padding: 20px;
  }
}
</style>